import { type IHotel, RenovationType } from '@entities/hotel';

function filterHotelByRenovation(hotel: IHotel, renovations: RenovationType[]): boolean {
    if(!renovations.length) return true;

    if(!hotel.renovationType) return false;

    return renovations.includes(hotel.renovationType);
}

export default filterHotelByRenovation;
